import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'janavirucham_frontend';
  ngOnInit() {
    this.setToken();
    // document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");
  }
  setToken() {
    // sessionStorage.setItem("accessToken", "test");
  }
}
